module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/qa/male_medical_team-f7158da92c798b0e7aeca7c46f80ab2b.png";